import Cookies from "js-cookie";

export class XylemCookies {
	constructor() {
		this.keys = {
			countryCookie: "xyl-countryPrompt",
		};
	}

	setCookieValue(cookieName, value, expiryInDays = 4383) {
		Cookies.set(cookieName, `${value}`, { expires: expiryInDays });
	}

	setSessionCookie(cookieName, value) {
		Cookies.set(cookieName, `${value}`);
	}

	getCookieValue(cookieName) {
		const cookie = Cookies.get(cookieName);
		return cookie ?? "";
	}

	getCountryPromptCookie() {
		const cookie = Cookies.get(this.keys.countryCookie);
		return cookie ?? "";
	}

	setCountryPromptCookie(expiration) {
		Cookies.set(this.keys.countryCookie, `${true}`, expiration);
	}
}
